import React from "react";
import CopyToClipboard from "@amzn/awsui-components-react/polaris/copy-to-clipboard";
import "../ellipsisText/EllipsisText.css";

export const COPY_ID_LABEL = "Copy ID to clipboard";

/** An icon button that copies an id to the clipboard; placed to the left of the id it copies. */
export default function CopyIdButton({text}) {
    if (!text) {
        return null;
    }
    return (
        <span className="copyIdButton">
            <CopyToClipboard variant="icon" textToCopy={text} copyButtonAriaLabel={COPY_ID_LABEL}
                             copySuccessText="Copied" copyErrorText="Failed to copy" />
        </span>
    );
}
